(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });


  document.addEventListener('DOMContentLoaded', function() {
  // Find the main navigation
  const mainNav = document.querySelector('nav[aria-label="Primary"]');
  
  if (mainNav) {
    // Find all links in the main navigation
    const navLinks = mainNav.querySelectorAll('a.main-nav__item--primary');
    
    // Make all main navigation links font weight 600
    navLinks.forEach(link => {
      link.style.fontWeight = '600';
      
      // Change color of the Sale link
      if (link.textContent.trim() === 'Sale') {
        link.style.color = 'rgb(203, 22, 39)';
      }
    });
  }
});


(function () {
  'use strict';

  const isTouchLike = window.matchMedia('(hover: none), (pointer: coarse)').matches;

  function setup() {
    const navDetails = document.querySelectorAll('.main-nav > li > details');

    navDetails.forEach((d) => {
      const summary = d.querySelector(':scope > summary');
      const link = summary?.querySelector('a.main-nav__item--primary');

      if (!summary || !link) return;

      // IMPORTANT: On touch devices (iPad/tablet), Shopify sets tabindex=-1 on md+,
      // which makes toggling flaky. Put it back so it can be interacted with.
      if (isTouchLike) summary.removeAttribute('tabindex');

      // Single tap behavior for touch devices
      link.addEventListener('click', (e) => {
        if (!isTouchLike) return;

        // Check if this dropdown is a mega menu (has dropdown content)
        const hasDropdown = d.querySelector('.main-nav__child');
        
        if (hasDropdown) {
          e.preventDefault();
          
          // If this dropdown is already open, navigate to the link
          if (d.hasAttribute('open')) {
            window.location.href = link.href;
            return;
          }
          
          // Close other open menus
          navDetails.forEach((other) => {
            if (other !== d) other.removeAttribute('open');
          });
          
          // Open this dropdown
          d.setAttribute('open', '');
        }
        // If it doesn't have a dropdown, just navigate normally
      }, { passive: false });

      // Handle clicks on the summary itself (the arrow/button area)
      summary.addEventListener('click', (e) => {
        if (!isTouchLike) return;
        
        const hasDropdown = d.querySelector('.main-nav__child');
        
        if (hasDropdown) {
          e.preventDefault();
          
          if (d.hasAttribute('open')) {
            d.removeAttribute('open');
          } else {
            navDetails.forEach((other) => {
              if (other !== d) other.removeAttribute('open');
            });
            d.setAttribute('open', '');
          }
        }
      });
    });
  }

  // Close menus when tapping outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.main-nav')) {
      document.querySelectorAll('.main-nav > li > details[open]').forEach(d => d.removeAttribute('open'));
    }
  });

  // Close menus on scroll (optional but makes it stable)
  let scrollTimer;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      document.querySelectorAll('.main-nav > li > details[open]').forEach(d => d.removeAttribute('open'));
    }, 120);
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

(function () {
  'use strict';

  const isHoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!isHoverCapable) return;

  function setupHover() {
    const navDetails = document.querySelectorAll('.main-nav > li > details');

    navDetails.forEach((d) => {
      let t;
      let isHovering = false;

      const panel = d.querySelector(':scope > .main-nav__child');

      const openNow = () => {
        clearTimeout(t);
        isHovering = true;
        // close others
        navDetails.forEach((other) => { if (other !== d) other.removeAttribute('open'); });
        d.setAttribute('open', '');
      };

      const scheduleClose = () => {
        isHovering = false;
        clearTimeout(t);
        t = setTimeout(() => {
          // Only close if we're not hovering over the dropdown
          if (!isHovering) {
            d.removeAttribute('open');
          }
        }, 350); // Increased from 220ms to 350ms for better hover transition
      };

      d.addEventListener('mouseenter', openNow);
      d.addEventListener('mouseleave', scheduleClose);

      if (panel) {
        panel.addEventListener('mouseenter', () => {
          clearTimeout(t);
          isHovering = true;
        });
        panel.addEventListener('mouseleave', scheduleClose);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupHover);
  } else {
    setupHover();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
